import apiClient from "@/utils/httpClient";
import { ReminderDto, CreateReminderDto } from "@blinkbooks/types";

export const getReminders = async (): Promise<ReminderDto[]> => {
  const response = await apiClient.getRaw<{ success: boolean; data: ReminderDto[] }>('/reminders');
  return response?.data ?? [];
};

export const markReminderRead = async (id: string): Promise<void> => {
  await apiClient.request(`/reminders/${id}/read`, { method: 'PATCH' });
};

export const createReminder = async (data: CreateReminderDto): Promise<void> => {
  await apiClient.post('/reminders', data);
};
